define(
    '../../widgets/select/main',[
        'jquery',
        'utils/bind-manager'
    ],
    function ($, bindMng) {
        return function () {
            bindMng.add('.select select', 'focus', function () {
                $(this).parent().addClass('select--focused');
            });

            bindMng.add('.select select', 'blur', function () {
                $(this).parent().removeClass('select--focused');
            });
        };
    }
);
